import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 32,
		height: 32,
		rx: 6,
		fill: "#24A2C2"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.1667 8.5L21.8333 16L10.1667 23.5V8.5Z",
		stroke: "#DFF1FA",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgLive;
